import { Button, Callout, Dialog, FormGroup, NumericInput } from '@blueprintjs/core'
import * as React from 'react'
import Client from '../../../client'
import { UprightStyle } from '../../../types'
import { showSuccess } from '../../../Toast'

const styles: UprightStyle = {
  numberOfCopiesInput: { width: '100%' },
  callout: { marginBottom: 20 }
}

interface PropsInterface {
  productIds: number[]
  isOpen: boolean
  onClose: () => void
  onDuplicateComplete: () => void
}

const DuplicateDialog = ({ productIds = [], isOpen, onClose, onDuplicateComplete }: PropsInterface) => {
  const [loading, setLoading] = React.useState(false)
  const [errorMessages, setErrorMessages] = React.useState(null)
  const [numberOfCopies, setNumberOfCopies] = React.useState<number>(1)

  const duplicateProduct = async () => {
    setLoading(true)
    setErrorMessages(null)

    try {
      await Client.duplicateProducts(productIds, numberOfCopies)
      setLoading(false)
      showSuccess(`Product${productIds.length > 1 ? 's' : ''} successfully duplicated.`)
      onDuplicateComplete()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
      setLoading(false)
      setErrorMessages(e.response.data.errors)
    }
  }

  return (
    <Dialog
      title="How many copies would you like to make?"
      isOpen={isOpen}
      onClose={() => {
        setErrorMessages(null)
        onClose()
      }}
    >
      <div className="bp3-dialog-body">
        {errorMessages && (
          <Callout intent="danger" title="Failed to duplicate" style={styles.callout}>
            {errorMessages.map(errorMessage => (
              <p>{errorMessage}</p>
            ))}
          </Callout>
        )}
        <FormGroup
          label={`Number of copies ${productIds.length > 1 ? 'of each' : ''}`}
          style={styles.numberOfCopiesInput}
        >
          <NumericInput
            fill
            value={numberOfCopies}
            onValueChange={num => setNumberOfCopies(num)}
            min={1}
            max={50}
            minorStepSize={1}
            clampValueOnBlur
          />
        </FormGroup>
      </div>
      <div className="bp3-dialog-footer">
        <div className="bp3-dialog-footer-actions">
          <Button minimal onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={duplicateProduct} disabled={numberOfCopies < 1} intent="primary" loading={loading}>
            {productIds.length > 1 && `Duplicate ${productIds.length} products`}
            {productIds.length === 1 && 'Duplicate product'}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default DuplicateDialog
